module.exports = __webpack_public_path__ + "img/salsa_1349.c79b5136.jpg";